<!-- Divider -->
<div
    class="fuse-vertical-navigation-item-wrapper divider text-sidebar-300"
    [ngClass]="item.classes?.wrapper"
></div>
